import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";

export const ContactApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        getContactByRelationId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-all-contact-by-relationId/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['contactsById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),


        createContact: build.mutation({
            query: ({ contactId, requestBody }) => {
                return {
                    url: `/ajax/create-contact/${contactId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['contactsById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Contact");
            },
        }),

        updateContact: build.mutation({
            query: ({ contactId, requestBody }) => {
                return {
                    url: `/ajax/update-contact/${contactId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['contactsById','contactById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Contact");
            },
        }),

        deleteContactsById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-contact-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['contactsById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Contacts");
            },
        }),
    })
})

export const {
    useCreateContactMutation,
    useUpdateContactMutation,
    useDeleteContactsByIdMutation,
    useGetContactByRelationIdQuery
} = ContactApi